<template>
    <app-layout-main title="rooomGuide CMS">

        <template v-slot:left-area>
            <div class="mb-5 p-2">
                <div class="search-wrapper">
                   <input
                        class="input-black"
                        type="text"
                        :value="searchQuery"
                        @input="searchTour($event.target.value)"
                        placeholder="Search tour..."
                    >
                   <i class="search"></i>
                </div>

                <ul class="categories">
                    <li v-for="cat in categories">
                        <div class="flex justify-between cursor-pointer">
                            <span @click.prevent="filter(cat.filterKey)" class="flex icon-name items-center">
                                <i :class="cat.icon"></i>
                                <span>{{ cat.name }}</span>
                            </span>
<!--                            <span class="number-wrapper">-->
<!--                                <span class="number">{{ cat.count }}</span>-->
<!--                            </span>-->
                        </div>
                    </li>
                </ul>

            </div>
        </template>

        <TourCardGrid />

    </app-layout-main>
</template>

<script>
import AppLayoutMain from '@/Layouts/AppLayoutMain.vue'
import TourCardGrid from '@/Pages/Tour/Partials/TourCardGrid.vue'
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayoutMain,
        TourCardGrid,
        Link,
    },

    props: {
        locale: String,
    },
    data() {
        return {
            show: false,
            tours: this.$page.props.tours.data,
            searchQuery: '',
            categories: [
                {
                    name: 'All',
                    icon: 'ricon-rooms',
                    count: 24,
                    filterKey: 'all',
                },
                // {
                //     name: 'Adults',
                //     icon: 'adults',
                //     count: 12,
                // },
                // {
                //     name: 'Kids',
                //     icon: 'kids',
                //     count: 12,
                // },
                // {
                //     name: 'Easy language',
                //     icon: 'easy-language',
                //     count: 12,
                // },
                // {
                //     name: 'Favourites',
                //     icon: 'favourites',
                //     count: 12,
                // }
            ]
        }
    },
    methods: {
        searchTour(query) {
            this.searchQuery = query;
            // sorry for that mess, a Store whould be great, when handling with such data
            this.tours.forEach(tour => {
                let found = false;
                ['title', 'subtitle'].forEach(key => {
                    for(let langKey in tour[key].localized_text) {
                        if(tour[key].localized_text[langKey].indexOf(query) > -1) {
                            found = true;
                        }
                    }
                });
                if(found) { tour.isVisible = true; }
                else { tour.isVisible = false; }
            });
        },
        filter(key) {
            if(key === 'all') {
                this.searchQuery = '';
                this.tours.map(tour => tour.isVisible = true);
            }
        }
    },
}
</script>
